import { render, staticRenderFns } from "./register.vue?vue&type=template&id=899601f8&scoped=true&"
import script from "./register.vue?vue&type=script&lang=ts&"
export * from "./register.vue?vue&type=script&lang=ts&"
import style0 from "./register.vue?vue&type=style&index=0&id=899601f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899601f8",
  null
  
)

export default component.exports